import React, { useContext } from "react";
import { Navigate } from "react-router";
import { DealerAccountContext } from "../../../context/DealerAccountContext";
import { RBACAccessContext } from "../../../context/RBACAccessContext/RBACAccessContext";
import { UserContext } from "../../../context/UserContext/UserContext";
import LocalStorage from "../../../utils/LocalStorage";

function JDRoleLandingViewWrapper({ children }: { children: React.ReactNode }) {
  const { isRBACEnabled } = useContext(RBACAccessContext);
  const user = useContext(UserContext);
  const dealer = useContext(DealerAccountContext);

  if (
    isRBACEnabled &&
    user?.isUserWithJDRole() &&
    dealer?.dealerAccount?.id === undefined &&
    !(LocalStorage.getJSONValue("jdRoleActivity")
      ?.lastVisitedAccountId as string)
  ) {
    return <Navigate to="/my-dashboard" />;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}

export default JDRoleLandingViewWrapper;
